import { c as _c } from "react/compiler-runtime";
import { IconShieldExclamation } from "@tabler/icons-react";
import { Alert, AlertDescription, AlertTitle } from "@domainstack/ui/alert";
import { cn } from "@domainstack/ui/utils";
import { describeTlsValidationError } from "@domainstack/utils/tls";
export function CertificateAlert(t0) {
  const $ = _c(24);
  let className;
  let props;
  let title;
  let validationError;
  if ($[0] !== t0) {
    ({
      validationError,
      className,
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = title;
    $[4] = validationError;
  } else {
    className = $[1];
    props = $[2];
    title = $[3];
    validationError = $[4];
  }
  let t1;
  if ($[5] !== validationError) {
    t1 = describeTlsValidationError(validationError);
    $[5] = validationError;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const copy = t1;
  const description = copy.description;
  const resolvedTitle = title ?? copy.title;
  let t2;
  if ($[7] !== className) {
    t2 = cn(className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconShieldExclamation aria-hidden={true} className="size-4" />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== resolvedTitle) {
    t4 = <AlertTitle>{resolvedTitle}</AlertTitle>;
    $[10] = resolvedTitle;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== description) {
    t5 = <p>{description}</p>;
    $[12] = description;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== validationError) {
    t6 = validationError ? <p className="font-mono text-[11px] text-muted-foreground">{validationError}</p> : null;
    $[14] = validationError;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <AlertDescription>{t5}{t6}</AlertDescription>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== props || $[20] !== t2 || $[21] !== t4 || $[22] !== t7) {
    t8 = <Alert variant="destructive" className={t2} {...props}>{t3}{t4}{t7}</Alert>;
    $[19] = props;
    $[20] = t2;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}